// Web mock for `react-native-onesignal`.
//
// The real package calls TurboModuleRegistry.getEnforcing("OneSignal") at
// module-load time, which throws on web because react-native-web has no such
// native module. This no-op shim keeps the same public surface so imports and
// calls elsewhere in the app succeed without crashing the web bundle.

const noop = () => {};
const asyncNoop = async () => undefined;

export const LogLevel = {
  None: 0,
  Fatal: 1,
  Error: 2,
  Warn: 3,
  Info: 4,
  Debug: 5,
  Verbose: 6,
};

export const OneSignal = {
  initialize: noop,
  login: noop,
  logout: noop,
  Debug: {
    setLogLevel: noop,
    setAlertLevel: noop,
  },
  User: {
    addTags: noop,
    addTag: noop,
    removeTag: noop,
    removeTags: noop,
    getTags: asyncNoop,
    addEmail: noop,
    removeEmail: noop,
    addSms: noop,
    removeSms: noop,
    addAlias: noop,
    removeAlias: noop,
    setLanguage: noop,
    pushSubscription: {
      optIn: noop,
      optOut: noop,
      getIdAsync: asyncNoop,
      getTokenAsync: asyncNoop,
      getOptedInAsync: async () => false,
      addEventListener: noop,
      removeEventListener: noop,
    },
  },
  Notifications: {
    addEventListener: noop,
    removeEventListener: noop,
    getPermissionAsync: async () => false,
    requestPermission: async () => false,
    canRequestPermission: async () => false,
    hasPermission: () => false,
    clearAll: noop,
    removeNotification: noop,
    removeGroupedNotifications: noop,
  },
  InAppMessages: {
    addTrigger: noop,
    addTriggers: noop,
    removeTrigger: noop,
    removeTriggers: noop,
    clearTriggers: noop,
    addEventListener: noop,
    removeEventListener: noop,
    setPaused: noop,
    getPaused: async () => false,
  },
  Location: {
    setShared: noop,
    isShared: async () => false,
    requestPermission: asyncNoop,
  },
  Session: {
    addOutcome: noop,
    addUniqueOutcome: noop,
    addOutcomeWithValue: noop,
  },
  LiveActivities: {
    enter: noop,
    exit: noop,
  },
};

export default OneSignal;
